import APIController from '../core-api-controller';

export const fetchCouponsApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/promotion_codes${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchCouponApi = (id = '') => {
  const path = `${APIController.endpointApi}/promotion_codes/${id}`;
  return APIController.getApiCallback(path);
};

export const createCouponApi = (data = {}) => {
  const path = `${APIController.endpointApi}/promotion_codes`;
  return APIController.postCallback(path, data);
};

export const updateCouponApi = (id = '', data = {}) => {
  const path = `${APIController.endpointApi}/promotion_codes/${id}`;
  return APIController.putCallback(path, data);
};

export const deleteCouponApi = (id = '') => {
  const path = `${APIController.endpointApi}/promotion_codes/${id}`;
  return APIController.deleteCallback(path);
};

export const syncCouponsApi = () => {
  const path = `${APIController.endpointApi}/promotion_codes/sync`;
  return APIController.postCallback(path);
};
